import { LOAD_SEARCH_COMMENTS } from 'constants/ActionTypes';
import { loadEntities } from 'helpers/utilHelpers';
import { all, fork, takeEvery } from 'redux-saga/effects';

function* loadSearchComments() {
  yield takeEvery(LOAD_SEARCH_COMMENTS, loadEntities);
}

export default function* rootSaga() {
  yield all([fork(loadSearchComments)]);
}
